<template>
  <v-app>
    <router-view></router-view>
    <!-- <hello-world /> -->
  </v-app>
</template>

<script>
import Login from './components/login.vue'
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components:{
    Login,
    HelloWorld
  },
  data: () => ({
    //
  }),
};
</script>
